import dayjs from "dayjs";
import { Event } from "interfaces/events";

/*
Filters the events on searchterm and categories, as well as sorting events based on start time
*/
export const getFilteredEvents = (events: Event[], searchTerm: string, sectors: number[]) =>
  events
    .filter(
      // Filter on search term
      event => searchTerm === "" || event.name.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .filter(
      // Filter on company sectors
      event => !sectors.length || event.sectors.some(eventSector => sectors.includes(eventSector))
    )
    .sort((a, b) => dayjs(a.start).valueOf() - dayjs(b.start).valueOf());

/*
Return a string that will be displayed with empty icon when there is either 
no events matching the search or no data recived from backend
*/
export const getEventStatusMessage = (events: Event[]) => {
  if (events.length) {
    return "Ingen arrangementer tilfredstiller ditt søk";
  }
  return "Ingen arrangementer er tilgjengelige for øyeblikket";
};
